<nav class="tabbar" aria-label="Fő navigáció">
  <a class="tabbar__item" *ngFor="let tab of tabs" [routerLink]="tab.link" routerLinkActive="tabbar__item--on"
     [class.tabbar__item--dim]="menuOpen" (click)="closeMenu()">
    <span class="tabbar__icon" [innerHTML]="tab.icon"></span>
    <span class="tabbar__badge" *ngIf="badgeOf(tab) > 0">{{ badgeOf(tab) > 99 ? '99+' : badgeOf(tab) }}</span>
    <span class="tabbar__label">{{ tab.short }}</span>
  </a>
  <button type="button" class="tabbar__item" [class.tabbar__item--on]="menuOpen" (click)="toggleMore()" aria-label="Teljes menü">
    <span class="tabbar__icon" [innerHTML]="moreIcon"></span>
    <span class="tabbar__label">Több</span>
  </button>
</nav>
